module.exports = __webpack_public_path__ + "static/add-ons-and-allowances-50321226e1f29cc5c3d1d02cc6f73d62.svg";